import React, { useState, useEffect } from "react";
import {
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Box,
  Typography,
  SelectChangeEvent,
} from "@mui/material";

import { clientsAPI } from "../services/api";

interface Client {
  id: string;
  name: string;
  subdomain?: string;
}

const TenantSelector: React.FC = () => {
  const [clients, setClients] = useState<Client[]>([]);
  const [selectedTenant, setSelectedTenant] = useState<string>(
    localStorage.getItem("clientId") || "",
  );
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    // Load clients when component mounts
    const fetchClients = async () => {
      try {
        const clientsData = await clientsAPI.getAll();

        setClients(clientsData || []);
      } catch (error) {
        console.error("Error fetching clients:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchClients();
  }, []);

  const handleTenantChange = (event: SelectChangeEvent<string>) => {
    const value = event.target.value;

    setSelectedTenant(value);

    // Store clientId in localStorage
    if (value) {
      localStorage.setItem("clientId", value);

      // Find the client name for the selected client
      const selectedClient = clients.find(
        (client) => client.id.toString() === value,
      );

      if (selectedClient) {
        localStorage.setItem("clientName", selectedClient.name);
      }
    } else {
      localStorage.removeItem("clientId");
      localStorage.removeItem("clientName");
    }

    // Reload page to apply tenant change
    window.location.reload();
  };

  if (loading) {
    return <Typography>Loading clients...</Typography>;
  }

  return (
    <Box sx={{ minWidth: 200 }}>
      <FormControl fullWidth>
        <InputLabel id="tenant-select-label">Client</InputLabel>
        <Select<string>
          id="tenant-select"
          label="Client"
          labelId="tenant-select-label"
          value={selectedTenant}
          onChange={handleTenantChange}
        >
          <MenuItem value="">
            <em>All Clients</em>
          </MenuItem>
          {clients.map((client) => (
            <MenuItem key={client.id} value={client.id.toString()}>
              {client.name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
};

export default TenantSelector;
